import React from 'react';
import { motion } from 'framer-motion';
import { Gift, FileText, Wind, MessageSquare, Users } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    num: 1,
    icon: <FileText className="w-8 h-8 text-gold" data-id="element-30" />,
    img: 'https://cdn.magicpatterns.com/uploads/cL7mnEDM47iXHUSDscjPKB/Captura_de_pantalla_2026-06-11_134532.png',
    title: 'Diario de Transformación Personal',
    subtitle: '(Workbook Imprimible)',
    desc: 'un diario de transformación de 21 días. El objetivo es ayudar a las personas que sufren de ansiedad u otros desequilibrios emocionales. Cada día contiene un mensaje, reflexión, tarea y espacio para escribir.',
    value: '$12.000'
  }, {
    num: 2,
    icon: <Wind className="w-8 h-8 text-gold" data-id="element-31" />,
    img: 'https://cdn.magicpatterns.com/uploads/r7hQuH7eSEZhyzWEVzASXt/Captura_de_pantalla_2026-06-11_132855.png',
    title: 'El Poder de Dejar Ir - Rompe Con Relaciones Toxicas',
    subtitle: '',
    desc: "'Rompe con Relaciones Tóxicas' de Serena Wellington aborda la importancia de identificar y liberarse de relaciones dañinas que afectan el bienestar emocional.",
    value: '$15.000'
  }, {
    num: 3,
    icon: <MessageSquare className="w-8 h-8 text-gold" data-id="element-32" />,
    img: 'https://cdn.magicpatterns.com/uploads/spZPJi1mCmYtWbmTLG8Aeo/9798278385349.jpg',
    title: 'Primero Yo Despues el Resto',
    subtitle: '',
    desc: "'Primero Yo, Después el Resto' de Aurora S. ofrece 120 sesiones de autoconocimiento y empoderamiento personal, enfocándose en la importancia de priorizarse a uno mismo y liberarse de la culpa.",
    value: '$10.000'
  }, {
    num: 4,
    icon: <Users className="w-8 h-8 text-gold" data-id="element-33" />,
    img: 'https://cdn.magicpatterns.com/uploads/fTu523TuSHi7FSXmxBvw1q/Captura_de_pantalla_2026-06-11_133243.png',
    title: 'Como Cambiar Tu Vida en 50 Hojas',
    subtitle: '',
    desc: 'cómo mejorar la autoestima en 50 páginas. Explica conceptos como autoestima, autoconocimiento, amor propio y aceptación. El objetivo es ayudar a las personas a descubrir su verdad interior y mejorar su vida.',
    value: '$15.000'
  }];
  return <section className="py-12 md:py-16 bg-dark text-white relative overflow-hidden" data-id="element-34">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-teal/20 via-dark to-dark opacity-50" data-id="element-35"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-37">
          <div className="inline-flex items-center justify-center gap-2 bg-gold text-dark px-6 py-2 rounded-full font-bold tracking-wider uppercase mb-6" data-id="element-38">
            <Gift className="w-5 h-5" data-id="element-39" />
            <span data-id="element-40">Apilamiento de valor</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-41">
            4 BONOS ESTRATÉGICOS INCLUIDOS GRATIS HOY:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10" data-id="element-42">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm relative overflow-hidden group hover:bg-white/10 transition-colors" data-id="element-43">
              <div className="absolute -right-4 -top-4 text-9xl font-display font-bold text-white/5 group-hover:text-white/10 transition-colors pointer-events-none" data-id="element-44">
                {bono.num}
              </div>

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-45">
                {bono.img ? <div className="w-20 h-28 flex-shrink-0 rounded-xl overflow-hidden shadow-lg ring-1 ring-white/10" data-id="element-46">
                    <img src={bono.img} alt={bono.title} className="w-full h-full object-cover" data-id="element-47" />
                  </div> : <div className="bg-gold/20 p-4 rounded-2xl" data-id="element-48">{bono.icon}</div>}
                <div data-id="element-49">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider mb-1" data-id="element-50">
                    BONO {bono.num}
                  </div>
                  <h3 className="text-xl font-display font-bold leading-tight" data-id="element-51">
                    {bono.title}
                    {bono.subtitle}
                  </h3>
                </div>
              </div>

              <p className="text-cream-dark mb-6 relative z-10 text-[14px]" data-id="element-52">
                {bono.desc}
              </p>

              <div className="flex items-center justify-between border-t border-white/10 pt-4 relative z-10" data-id="element-53">
                <span className="text-white/50 line-through text-lg" data-id="element-54">
                  {bono.value}
                </span>
                <span className="bg-coral text-white font-bold px-4 py-1 rounded-full text-sm" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold to-yellow-400 p-1 rounded-3xl" data-id="element-56">
          <div className="bg-dark rounded-[22px] p-8 text-center" data-id="element-57">
            <p className="text-2xl md:text-3xl font-display font-bold text-white" data-id="element-58">
              Valor total de los bonos:{' '}
              <span className="text-white/50 line-through mx-2" data-id="element-59">$52.000</span>
              <span className="text-gold block md:inline mt-2 md:mt-0" data-id="element-60">
                ➔ ¡GRATIS HOY CON TU LIBRO!
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}